// @flow
import { Store } from '@homie/flux';
import $ from 'jquery';
import * as CurrentUserActionType from 'action_types/CurrentUserActionTypes';
import Dispatcher from 'dispatcher';
import CurrentUser from 'models/CurrentUser';
import LegalEntity from 'models/LegalEntity';

const CHANGE = 'change';
const POLLING_CHANGE = 'polling_change';
const REMOVED_USER = 'emit_removed_user';
let _currentUser = new CurrentUser();
let _mapKey = '';

class AppStore extends Store {
  constructor(): void {
    super();
    Dispatcher.register(this._actionsHandler);
    this._obtainMapKey();
  }

  getCurrentUser = (): CurrentUser => {
    return _currentUser;
  };

  getLegalEntity = (): Array<LegalEntity> => {
    return _currentUser.legal_entity;
  };

  getMapKey = () => {
    return _mapKey;
  };

  getGoogleMapsUrl = () => {
    return `https://maps.googleapis.com/maps/api/js?key=${this.getMapKey()}&v=3.exp&libraries=geometry,drawing,places`;
  };

  removeAccents = str => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };

  getGoogleMapsUrlToObjectAutocomplete = address => {
    return `https://maps.googleapis.com/maps/api/geocode/json?region=mx&components=country:MX&key=${this.getMapKey()}&address=${this.removeAccents(
      address
    )}`;
  };

  addChangeListener = (callback: () => void) => {
    this.on(CHANGE, callback);
  };

  removeChangeListener = (callback: () => void) => {
    this.removeListener(CHANGE, callback);
  };

  addPollingChangeListener = (callback: () => void) => {
    this.on(POLLING_CHANGE, callback);
  };

  removePollingChangeListener = (callback: () => void) => {
    this.removeListener(POLLING_CHANGE, callback);
  };

  addUserListener = (callback: () => void) => {
    this.on(REMOVED_USER, callback);
  };

  removeUserListener = (callback: () => void) => {
    this.removeListener(REMOVED_USER, callback);
  };

  _setCurrentUser = (currentUser: CurrentUser) => {
    _currentUser = currentUser;
  };

  _setPollingCurrentUser = (
    currentUser: CurrentUser,
    agency: any,
    idAdvisor: string
  ) => {
    if (JSON.stringify(_currentUser) === JSON.stringify(currentUser)) {
      return false;
    } else {
      _currentUser = currentUser;
      if (agency) {
        _currentUser.agency = agency;
        _currentUser.idAdvisor = idAdvisor;
      }
      return true;
    }
  };

  _removeCurrentUser = (): void => {
    _currentUser = new CurrentUser();
  };

  _setLegalEntity = (data: any): void => {
    _currentUser.legal_entity = new LegalEntity(data.legal_entity);
    this._setCurrentUser(_currentUser);
  };

  _obtainMapKey = () => {
    const meta = $('meta[name="homie-maps-key"]');
    if (meta) {
      _mapKey = meta.attr('content');
      meta.remove();
    }
  };

  _setLastCodeDate = (lastCodeDate: Date) => {
    _currentUser.lastCodeDate = lastCodeDate;
    _currentUser.codeCreationDate = lastCodeDate;
  };

  _emitChange = () => {
    this.emit(CHANGE);
  };

  _emitPollingChange = () => {
    this.emit(POLLING_CHANGE);
  };

  _emitRemovedUser = () => {
    this.emit(REMOVED_USER);
  };

  updateCurrentUser = (key: string, value: any) => {
    _currentUser[key] = value;
  };

  _actionsHandler = (action: any) => {
    switch (action.type) {
      case CurrentUserActionType.CURRENT_USER_POLLING_LOADED: {
        if (
          this._setPollingCurrentUser(
            action.currentUser,
            action.agency,
            action.idAdvisor
          )
        ) {
          this._emitPollingChange();
        }
        break;
      }
      case CurrentUserActionType.CURRENT_USER_LOADED: {
        this._setCurrentUser(action.currentUser);
        this._emitChange();
        this._emitPollingChange();
        break;
      }
      case CurrentUserActionType.CURRENT_USER_REMOVE: {
        this._removeCurrentUser();
        this._emitPollingChange();
        this._emitRemovedUser();
        break;
      }
      case CurrentUserActionType.LEGAL_ENTITY_EDIT: {
        this._setLegalEntity(action.data);
        this._emitChange();
        break;
      }
      case CurrentUserActionType.LEGAL_ENTITY_CREATE: {
        this._setLegalEntity(action.data);
        this._emitChange();
        break;
      }
      case CurrentUserActionType.SET_LAST_CODE_DATE: {
        this._setLastCodeDate(action.data);
        this._emitChange();
        this._emitPollingChange();
        break;
      }
    }
    this.notify();
  };
}

export default new AppStore();
